import { render } from "./EmailPreview.vue?vue&type=template&id=0d08d8b3"
import script from "./EmailPreview.vue?vue&type=script&lang=js"
export * from "./EmailPreview.vue?vue&type=script&lang=js"

import "./EmailPreview.vue?vue&type=style&index=0&id=0d08d8b3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__